import { Directive, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HexColorCode, ImmomioIconName } from '../../models';

export enum IconFontVariant {
  REGULAR = '',
  BOLD = 'icon-bold',
  LIGHT = 'icon-light',
}

@Directive()
export abstract class IconBaseComponent implements OnInit {
  @Input() icon: ImmomioIconName;
  @Input() size = 26;
  @Input() variant: IconFontVariant = IconFontVariant.REGULAR;
  @Input() color: HexColorCode;
  @Input() otherClasses: string[] = [];
  @Input() textAlignment = 'left';
  @Input() thumb = false;
  @Input() rounded = false;
  @Input() pinned = false;
  @Output() tapped = new EventEmitter();
  public iconBaseClass = 'icon';

  ngOnInit(): void {
    if (!this.variant) {
      if (this.size > 36) {
        this.variant = IconFontVariant.LIGHT;
      } else if (this.size < 13) {
        this.variant = IconFontVariant.BOLD;
      }
    }
  }
}
